"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areErrorObjectsTheSame = void 0;
const areErrorObjectsTheSame = (err1) => (err2) => {
    var _a, _b, _c, _d, _e, _f;
    return err1.type === err2.type &&
        err1.message === err2.message &&
        ((_a = err1.stack[0]) === null || _a === void 0 ? void 0 : _a.filename) === ((_b = err2.stack[0]) === null || _b === void 0 ? void 0 : _b.filename) &&
        ((_c = err1.stack[0]) === null || _c === void 0 ? void 0 : _c.line) === ((_d = err2.stack[0]) === null || _d === void 0 ? void 0 : _d.line) &&
        ((_e = err1.stack[0]) === null || _e === void 0 ? void 0 : _e.column) === ((_f = err2.stack[0]) === null || _f === void 0 ? void 0 : _f.column);
};
exports.areErrorObjectsTheSame = areErrorObjectsTheSame;
//# sourceMappingURL=errorHandling.js.map